<div class="flex flex-col flex-auto min-w-0">

  <!-- Header -->
  <app-generic-breadcrumbs terminal="Dashboard" fallbackIcon="heroicons_solid:template"></app-generic-breadcrumbs>

  <!-- Main -->
  <div class="flex-auto p-6 sm:p-6">
    <!--loading-->
    <div *ngIf="viewState == viewStates.loading">
      <mat-spinner class="ml-auto mr-auto mt-5"></mat-spinner>
    </div>

    <app-dashboard-analytics *ngIf="viewState == viewStates.content" applicationRoute="v1/matchedLeadsProducts"
      [permissionsService]="permissionsService"></app-dashboard-analytics>
  </div>

</div>